
<div class="productConfigurator">
  <SetConfigurator v-if="isSet" v-model="selectedImages" :product="product" @addedToBasket="addedToBasket" @error="onError"/>
  <ImageBatchSelector v-else-if="needsBatchSelection" v-model="selectedImages" :product="product" @addedToBasket="addedToBasket" @error="onError"/>
  <SingleConfigurator v-else v-model="selectedImages" :product="product" @addedToBasket="addedToBasket" @error="onError"/>
</div>

